import { persist } from 'zustand/middleware';
import create from 'zustand';
import { tableColumns } from '../components/table/ColumnDefs';

type TableSection = 'main' | 'expanded';

type ColumnOrderState = {
   orders: Record<TableSection, string[]>;
   columnsMoveable: boolean;
   reorder: (section: TableSection, fromIndex: number, toIndex: number) => void;
   resetOrder: () => void;
   toggleMoveableColumns: () => void;
};

const getDefaultOrders = (): Record<TableSection, string[]> => ({
   main: tableColumns.main.map(c => c.accessorKey),
   expanded: tableColumns.expanded.map(c => c.accessorKey),
});

export const useColumnOrderState = create<ColumnOrderState>()(
   persist(
      (set) => ({
         orders: getDefaultOrders(),
         columnsMoveable: true,
         reorder: (section, fromIndex, toIndex) => set(state => {
            const next = [...state.orders[section]];
            const [moved] = next.splice(fromIndex, 1);
            next.splice(toIndex, 0, moved);
            return { orders: { ...state.orders, [section]: next } };
         }),
         resetOrder: () => set({ orders: getDefaultOrders() }),
         toggleMoveableColumns: () => set(state => ({ columnsMoveable: !state.columnsMoveable })),
      }),
      { name: 'column-order' }
   )
);